export const MainScene: any = {}